import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_site/legal/steam")({
  head: () => ({ meta: [{ title: "Steam disclaimer — NexKey.gg" }] }),
  component: () => (
    <article>
      <h1 className="font-display text-3xl font-bold">Steam disclaimer</h1>
      <p className="mt-4 text-sm text-muted-foreground">
        This website is not affiliated with Valve Corporation or Steam. Steam, the Steam logo and
        related assets are trademarks of Valve Corporation. Game data, prices and images shown as
        "Steam reference price" are sourced from publicly available Steam Storefront endpoints for
        the sole purpose of price comparison.
      </p>
    </article>
  ),
});
